import { getFlag } from 'routes/Flags/Flags';

/**
 * Matrix chat is still incomplete, so it ships enabled on beta and disabled on production via the
 * REACT_APP_MATRIX_ENABLED build arg. The /experimental override lets QA turn it on against a
 * production build without a rebuild, and takes precedence over the environment default.
 *
 * Deliberately imports nothing from services/matrix-connection so that gating a call site never
 * drags matrix-js-sdk into that call site's chunk.
 */
export const isMatrixEnabled = (): boolean => {
    const override = getFlag('useMatrixChat');
    if (override === 'YES') return true;
    if (override === 'NO') return false;
    // Absent or malformed env var falls back to disabled, so a build that forgets the arg fails safe.
    return process.env.REACT_APP_MATRIX_ENABLED === 'true';
};
